<template>
  <v-container  text-xs-start fluid>
    <v-layout column wrap>
        <v-flex>
                <NewSingleCapLog/>
        </v-flex>
        <v-flex v-bind:key="aLog.id" v-for="aLog in caplogs" xs6 lg12 class="terminal" v-on:keyup="updateCoordinates" v-on:keyup.space.ctrl="sayHi">
            <SingleCapLog v-if="aLog.log.length > 0"  v-bind:aLog="aLog"/>
        </v-flex>
    </v-layout>
    <v-footer fixed>
    <v-layout column justify-start wrap> 
        <v-flex lg12>
            <div contenteditable="false" ref="footer"></div>
        </v-flex>
    </v-layout>
    </v-footer>
    <!-- <SmarterContext v-bind:showMe="show"/> -->
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { capLogsService, loadCapLogs} from "../services/caplogsServices";
import SmarterContext from './SmarterContext'
import SingleCapLog from '../components/SingleCapLog'
import NewSingleCapLog from '../components/NewSingleCapLog'
import * as _ from 'lodash'

export default {
  components : {SmarterContext, SingleCapLog, NewSingleCapLog},
  data() {
    return {
      show : {
          open : false,
          x : 0,
          y : 0
      }
    };
  },
  computed: mapState(["ready","caplogs"]),
  ...{
    hello: function() {
      return "Hello";
    },
    
  },
  watch: {
    ready: function(ready) {
      if (ready) {
        this.loadCapLogs();
      } else {
        this.removeLogs();
      }
    }
  },
  created : function(){
      //this.saveDebounced  = _.debounce(this.saveNewCapLog,500,{maxWait:30000}) 
  },
  methods: {
    updateCoordinates(e){
    //console.log(e.type + " " + "clientX: " + e.clientX + " " + "clientY: " + e.clientY + " " + window.getSelection().anchorOffset)
    //     var sel = document.getSelection();
    // sel.modify("extend", "backward", "paragraphboundary");
    // var pos = sel.toString().length;
    // console.log('pos: '+pos);
    // if(sel.anchorNode != undefined) sel.collapseToEnd();

    // console.log(pos);
    this.show.x = window.getSelection().anchorOffset
    },
    sayHi(e) {
      this.menu = true
      let myThis = this
      this.show = {
      show : !myThis.show.open,
      x : window.getSelection().anchorOffset,
      y : e.clientY
      }
    },
    loadCapLogs() {
      loadCapLogs();
    },
    removeLogs() {
      this.$state.dispatch('removeLogs')
    },
    saveNewCapLog() {
        if(this.$refs.newLog.innerHTML == ''){
            console.log("Nothing to save")
            return
        }
        capLogsService(this.$refs.newLog.innerHTML);
        console.log("Saved " + this.$refs.newLog.innerHTML)
        //this.saveDebounced = _.debounce(updateNewLog())
    },
    addNewEmptyCapLog(){
        this.$store.dispatch("prepareForNewLog")
    }
  }
};
</script>
<style scoped>
.terminal {
  padding: 0px;
  outline: 0px solid transparent;
}

.newLog{
    border : 0px solid gray;
    outline: 0px solid transparent;
}
</style>
